import { use, useEffect, useRef } from 'react';
import { useChatContext } from '../contexts/ChatContext';
import { baseApiUrl } from '../constants/Api';
import { apiKey } from '../constants/Api';
import { useVesselContext } from '../contexts/VesselContext';
export function useChatMessages() {
    const { chats, setChats, lastMessageDataTime, setLastMessageDataTime } = useChatContext();
    const chatRef = useRef(chats);
    const getMessagesQueue = useRef(Promise.resolve());
    const { vessels } = useVesselContext();
    const vesselsRef = useRef(vessels);
    const lastMessageDataTimeRef = useRef(lastMessageDataTime);
    useEffect(() => {
        chatRef.current = chats;
        vesselsRef.current = vessels;
        lastMessageDataTimeRef.current = lastMessageDataTime;
    }, [chats, vessels, lastMessageDataTime]);
    const getMessages = async () => {
        let to = Date.now();
        let from = lastMessageDataTimeRef.current;
        try {
            const res = await fetch(`${baseApiUrl}message?from=${from}&to=${to}`, {
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                    "x-api-key": apiKey['x-api-key'],
                },
            });
            lastMessageDataTimeRef.current = to;
            setLastMessageDataTime(to);
            const data = await res.json();
            //
            const newChats = { ...chatRef.current };
            data["message"].forEach((element: any) => {
                const key = element.unitid ?? element.contactnumber;
                if (!newChats[key]) {
                    newChats[key] = {
                        lastReadTime: 0,
                        messages: [],
                        contactName: element.unitid ? vesselsRef.current[element.unitid]?.vesselName ?? "#" : "#",
                        contactNumber: element.contactnumber,
                        unitid: element.unitid,
                        read: true,
                        lastInBoundMessageIndex: -1,
                        lastRealMessageIndex: -1,
                    };
                    // Thêm số điện thoại vào cho vessels nếu cần
                    // if (element.unitid && vessels[element.unitid] && element.contactnumber){
                    //     let vessel = vessels[element.unitid];
                    //     if (!vessel.contactNumber) {
                    //         vessel.contactNumber = element.contactnumber;
                    //         setVessels(prev => {
                    //             const newVessels = { ...prev };
                    //             newVessels[element.unitid] = vessel;
                    //             return newVessels;
                    //         });
                    //     }
                    // } 
                }
                if (from == 1) {// giả lập: lần đầu lấy tin nhắn thì tất cả tin nhắn đều đã đọc
                    element.read = true;
                    newChats[key].lastReadTime = element.messagetime;
                    newChats[key].read = true;
                } else {
                    if (element.direction == 'in' && element.messagetime > newChats[key].lastReadTime) {
                        element.read = false;
                        newChats[key].read = false;
                    } else {
                        element.read = true;
                    }
                }
                if (newChats[key].lastRealMessageIndex < newChats[key].messages.length - 1) {
                    //nếu có tin nhắn được tạo local sẽ xoá bỏ nó để thêm loạt tin nhắn được tải vào
                    newChats[key].messages.splice(newChats[key].lastRealMessageIndex + 1);
                }
                element.index = newChats[key].messages.length;
                if (element.direction == 'in') {//lưu index của tin nhắn inbound cuối cùng
                    newChats[key].lastInBoundMessageIndex = element.index;
                }
                newChats[key].messages.push(element);
                newChats[key].lastRealMessageIndex++;
            });
            setChats(newChats);
        } catch (err) {
            console.error(err);
        }
    };

    // Hàm lấy tin nhắn theo hàng đợi
    const getMessagesQueued = () => {
        getMessagesQueue.current = getMessagesQueue.current.then(() => getMessages()).catch(console.error);
        return getMessagesQueue.current;
    };

    return { getMessages, getMessagesQueued };
}

export async function sendMessage(to: string, content: string) {
    try {
        const res = await fetch(`${baseApiUrl}message/${to}`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "x-api-key": apiKey["x-api-key"],
            },
            body: JSON.stringify({
                message: content,
            })
        });
        return res;
    } catch (err) {
        console.log(err);
        return null;
    }
}